module.exports = __webpack_public_path__ + "img/pdf-icon-11.80a6e8dc.jpg";